export class ExternalReferenceFinancial {
    _id: string = "";
    name: String = "";


    loadExternalReference(r: any) {
        
        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/ExternalReference.model.ts